import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AggregationRegisterResponse } from '@/repositories/generated';

const response: AggregationRegisterResponse = {
  id: '01FVSHW3S537KKHBRMSA418ATB',
};

export const campaignAggregation = http.post(
  createMockEndpoint('/aggregation/campaign'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
